import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] border-t border-red-900/20 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/cd80e8551adaa83aa4e45d1e4f56c590/c334bfc7bb42624cba9a352752f4949a.png"
                alt="Sinister Files"
                className="h-12 w-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-red-600 font-['Cinzel']">SINISTER FILES</h3>
                <p className="text-xs text-gray-400 font-['Crimson_Text'] italic">
                  Unearthing Dark Stories
                </p>
              </div>
            </div>
            <p className="text-gray-400 text-sm font-['Crimson_Text'] leading-relaxed mb-4">
              A community-driven platform for <strong>horror fiction enthusiasts</strong>. Share your darkest tales, 
              discover chilling stories, and connect with fellow writers who dare to explore the shadows.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-red-600/10 hover:bg-red-600 text-red-500 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-red-600/10 hover:bg-red-600 text-red-500 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-red-600/10 hover:bg-red-600 text-red-500 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://discord.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-red-600/10 hover:bg-red-600 text-red-500 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-discord-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4 font-['Cinzel']">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/stories"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  Browse Stories
                </Link>
              </li>
              <li>
                <Link
                  to="/top-ranked"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  Top Ranked
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/community"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  Community
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-bold mb-4 font-['Cinzel']">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/guidelines"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  Community Guidelines
                </Link>
              </li>
              <li>
                <Link
                  to="/guidelines#faq"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-red-500 transition-colors font-['Crimson_Text'] text-sm cursor-pointer"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-red-900/20 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-500 text-sm font-['Crimson_Text'] mb-4 md:mb-0">
            © 2026 Sinister Files. All rights reserved. Enter at your own risk.
          </p>
          <p className="text-gray-500 text-xs font-['Crimson_Text']">
            Last modified: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;